import * as React from 'react';
import autobind from 'autobind-decorator';
import { injectable, inject } from 'inversify';
import { resolve } from 'inversify-react';
import { RouteComponentProps } from 'react-router';
import { observable } from 'mobx';
import { observer } from 'mobx-react';

import { container } from 'src/inversify.config';
import { IdentityService } from 'src/core/services/identity.service';
import { LoginView } from './login.view';
import { ToastNotifications } from 'src/core/ui/toast';

/**
 * Login Controller
 */
@observer
export class LoginController extends React.Component<RouteComponentProps<any>, any> {
	@resolve
	private identityService: IdentityService;

	@resolve
	private toast: ToastNotifications;
	
	@observable
	protected model: LoginViewModel = {
		username: '',
		password: '',
		loginCommand: this.loginCommand
	};

	/**
	 * Constructor
	 */
	@autobind
	public loginCommand(): Promise<boolean> {
		const controller = this;
		return new Promise((resolve, reject) => {
			this.identityService.authenticate(this.model.username, this.model.password)
				.then((response) => {
					this.props.history.push('/home');
					resolve(true);
				})
				.catch(reject);
		});
	}

	componentDidMount() {
		Promise.resolve()
			.then(() => {
				if (this.props.location.state && this.props.location.state.requirePrivileges) {
					this.toast.showToast('Unauthorized', 'You do not have enough privileges to access to this resource.', 'error');
				}
			});
	}

	/**
	 * Render
	 */
	render() {
		return (
			<LoginView
				model={this.model}
				{...this.props}
			/>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/login/login.controller.tsx